export const wikiMetadata = [
    {
        id: 1,
        title: 'Добро пожаловать в Wiki',
        slug: 'welcome',
        category: 'Основное',
        filename: 'welcome.md',
        lastModified: '02.08.2025',
        author: 'whxtelxs',
        description: 'Введение в современную систему документации'
    },
    {
        id: 2,
        title: 'Быстрый старт',
        slug: 'getting-started',
        category: 'Основное',
        filename: 'getting-started.md',
        lastModified: '02.08.2025',
        author: 'whxtelxs',
        description: 'Руководство по быстрому началу работы'
    },
    {
        id: 3,
        title: 'API Документация',
        slug: 'api-docs',
        category: 'Разработка',
        filename: 'api-docs.md',
        lastModified: '02.08.2025',
        author: 'whxtelxs',
        description: 'Полная документация по REST API'
    },
    {
        id: 4,
        title: 'Руководство пользователя',
        slug: 'user-guide',
        category: 'Помощь',
        filename: 'user-guide.md',
        lastModified: '02.08.2025',
        author: 'whxtelxs',
        description: 'Подробное руководство по использованию системы'
    },
    {
        id: 5,
        title: 'Компоненты UI',
        slug: 'ui-components',
        category: 'Дизайн',
        filename: 'ui-components.md',
        lastModified: '02.08.2025',
        author: 'whxtelxs',
        description: 'Гайд по UI компонентам и стилям'
    }
]; 